import React from 'react';
import { Tag, TagType } from '../Tag';
import cn from './styles.module.scss';

type TagGroupProps = {
  tags: TagType[];
};

export const TagGroup = ({ tags }: TagGroupProps) => (
  <div className={cn.container}>
    {tags.map((tag) => (
      <Tag
        key={tag.id}
        className={cn.tag}
        tag={tag}
        maxLength={8}
        data-testid={`tag_${tag.name}`}
      />
    ))}
  </div>
);

export default TagGroup;
